import { Sets } from "@/types/mySpace";
import React, { useMemo, useState } from "react";
import styles from "./index.module.scss";
import { ReactComponent as NumIcon } from "@/assets/icons/mySpace/num.svg";
import { ReactComponent as LikeIcon } from "@/assets/icons/mySpace/like.svg";
import { ReactComponent as CollectIcon } from "@/assets/icons/mySpace/collect.svg";
import { ReactComponent as LookIcon } from "@/assets/icons/mySpace/look.svg";
import { ReactComponent as DeleteIcon } from "@/assets/icons/mySpace/delete.svg";
import { delRelease } from "../../api/mySpace";
import { formatTime } from "@/utils/time";
import { ImgAndPromptItemType } from "@/stores/gallery";

const IMG_COMPRESSION_W = 300;
interface IPubitem {
  info: Sets;
  idx: number;
  // localDelete: (idx: number) => void;
  handleDelete: (idx: number, id: number) => void;
  handleItemClicked: (info: ImgAndPromptItemType[], itemIdx: number) => void;
}

const PubItem: React.FC<IPubitem> = ({ info, handleDelete, idx, handleItemClicked }) => {
  const {
    cover_url,
    title,
    image_count,
    describe,
    like,
    look,
    collect,
    created_at,
    opus_id,
    width,
    height,
  } = info;
  const itemClicked = (e: any) => {
    e.stopPropagation();
    handleItemClicked(info.opus_image, idx);
  };

  const deleteClicked = async (e: any) => {
    e.stopPropagation();
    handleDelete(idx, opus_id);
    // const res = await delRelease({ del_type: 2, opus_id: opus_id });
  };

  const renderPubStatus = useMemo(() => {
    switch (info.status) {
      case 0: {
        return <>发布时间: {formatTime(created_at)}</>;
      }
      case 3:
      case 1: {
        return (
          <>
            <div className={styles["fail-status-point"]}></div> 审核失败 ，您可以调整后重新发布~
          </>
        );
      }
      case 2: {
        return (
          <>
            <div className={styles["process-status-point"]}></div>
            发布审核中，需要一些时间，请耐心等待
          </>
        );
      }
      default: {
        return <>发布时间: {formatTime(created_at)}</>;
      }
    }
  }, [info, info.status]);
  return (
    <div className={styles["pub-item-wrapper"]}>
      <div className={styles["img-wrapper"]} onClick={itemClicked}>
        <img src={`${cover_url}?x-oss-process=image/resize,w_${IMG_COMPRESSION_W}`} alt="" />
      </div>
      <div className={styles["info-wrapper"]}>
        <div className={styles["info-title"]}>{title}</div>
        <div className={styles["info-desc"]}>{describe}</div>
        <div className={styles["social-info"]}>
          {/* 点赞 */}
          <div className={styles["social-item"]}>
            <LikeIcon className={styles["social-icon"]} />
            {like}
          </div>
          {/* 收藏 */}
          {/* <div className={styles["social-item"]}>
            <CollectIcon className={styles["social-icon"]} />
            {collect}
          </div> */}
          {/* 查看 */}
          <div className={styles["social-item"]}>
            <LookIcon className={styles["social-icon"]} />
            {look}
          </div>
        </div>
      </div>
      <div className={styles["bottom-wrapper"]}>
        <div className={styles["pub-time"]}>{renderPubStatus}</div>
        <DeleteIcon className={styles["delete-icon"]} onClick={deleteClicked} />
      </div>
      {image_count > 1 && (
        <div className={styles["page-num"]}>
          <NumIcon className={styles["num-icon"]} />
          {image_count}
        </div>
      )}
    </div>
  );
};

export default PubItem;
